import { defineRule } from 'vee-validate'

defineRule('required', (value, empty, { field }) => {
  if (!value || !value.length) {
    return 'Campo obrigatório'
  }

  if (!value.replace(/\s/g, '').length) {
    return 'Campo não pode ser vazio'
  }

  return true
})

defineRule('required_if', (value, [other]) => {
  if (other === 'true' && (!value || !value.length)) {
    return 'Campo obrigatório'
  }

  return true
})

defineRule('email', (value) => {
  if (!value || !value.length) {
    return true
  }
  if (!/^([\w-\.]+@([\w-]+\.)+[\w-]{2,63})?$/.test(value.toUpperCase())) {
    return 'Digite um e-mail válido'
  }
  return true
})

defineRule('userName', (value) => {
  if (!value || !value.length) {
    return true
  }
  if (value.trim().split(' ').length < 2) {
    return 'Campo precisa conter nome e sobrenome'
  }
  return true
})

defineRule('date', (value) => {
  if (!value || !value.length) {
    return true
  }
  if (value === '00/00/0000') {
    return 'Insira uma data válida'
  }

  const __date = new Date(value.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$2/$1/$3'))

  if (
    !/([0-9]{2})[/]([0-9]{2})[/]([0-9]{4})/.test(value) ||
    !__date.getDate() ||
    __date.getMonth() + 1 > 12 ||
    __date.getFullYear() > 2007 ||
    __date.getFullYear() < 1900
  ) {
    return 'Data inválida ou idade não permitida'
  }

  return true
})

defineRule('confirmed', (value, [target], ctx) => {
  if (value === ctx.form[target]) {
    return true
  }
  return 'As senhas devem ser iguais.'
})

defineRule('isValidPassword', (value) => {
  if (value.length < 8) {
    return 'Digite no mínimo 8 caracteres.'
  }
  return true
})

defineRule('confirmedMail', (value, [target], ctx) => {
  if (value === ctx.form[target]) {
    return true
  }
  return 'Os e-mails devem ser iguais.'
})

defineRule('numeric', (value) => {
  if (!value || !value.length) {
    return true
  }
  const number = value.replace(/\D/g, '')
  if (!/^[0-9]*$/g.test(number)) {
    return 'Digite apenas números'
  }
  return true
})

defineRule('minLength', (value, [limit]) => {
  if (!value || !value.length) {
    return true
  }
  const min = value.replace(/[^a-zA-Z0-9]/g, '')
  if (min.length < limit) {
    return 'Quantidade de caracteres insuficiente'
  }
  return true
})

defineRule('minTextLength', (value, [limit]) => {
  if (!value || !value.length) {
    return true
  }
  if (value.length < limit) {
    return `Digite no mínimo ${limit} caracteres`
  }
  return true
})

defineRule('maxLength', (value, [limit]) => {
  if (!value || !value.length) {
    return true
  }
  const min = value.replace(/\D/g, '')
  if (min.length > limit) {
    return `Digite no máximo ${limit} caracteres`
  }
  return true
})

defineRule('tokenLimit', (value) => {
  if (!value || !value.length) {
    return true
  }
  if (value.length < 6) {
    return 'O campo deve ter 6 caracteres'
  }
  return true
})

defineRule('verifyFullName', (value) => {
  if (!value || !value.length) {
    return true
  }
  if (!/(\w{2})+\s(\w{1})+/.test(value)) {
    return 'Digite o nome completo'
  }
  return true
})

defineRule('userDocument', (value) => {
  if (!value || !value.length) {
    return true
  }
  const cpf = value.replace(/\D/g, '')
  let Soma
  Soma = 0
  if (cpf === '00000000000' || cpf === '000000000000000') {
    return 'Digite um CPF ou CNPJ válido'
  }

  if (cpf.length === 11) {
    let Resto
    for (let i = 1; i <= 9; i++) Soma = Soma + parseInt(cpf.substring(i - 1, i)) * (11 - i)
    Resto = (Soma * 10) % 11
    if (Resto === 10 || Resto === 11) Resto = 0
    if (Resto !== parseInt(cpf.substring(9, 10))) {
      return 'Digite um CPF ou CNPJ válido'
    }

    Soma = 0
    for (let i = 1; i <= 10; i++) Soma = Soma + parseInt(cpf.substring(i - 1, i)) * (12 - i)
    Resto = (Soma * 10) % 11
    if (Resto === 10 || Resto === 11) Resto = 0
    if (Resto !== parseInt(cpf.substring(10, 11))) {
      return 'Digite um CPF ou CNPJ válido'
    }
    return true
  } else if (cpf.length === 14) {
    let Resultado
    let Tamanho = 12
    let Pos = Tamanho - 7
    const Digitos = cpf.substring(Tamanho)
    let Numeros = cpf.substring(0, Tamanho)
    for (let i = Tamanho; i >= 1; i--) {
      Soma += Numeros.charAt(Tamanho - i) * Pos--
      if (Pos < 2) Pos = 9
    }
    Resultado = Soma % 11 < 2 ? 0 : 11 - (Soma % 11)
    if (Resultado !== parseInt(Digitos.charAt(0))) {
      return 'Digite um CPF ou CNPJ válido'
    }

    Tamanho = 13
    Numeros = cpf.substring(0, Tamanho)
    Soma = 0
    Pos = Tamanho - 7
    for (let i = Tamanho; i >= 1; i--) {
      Soma += Numeros.charAt(Tamanho - i) * Pos--
      if (Pos < 2) Pos = 9
    }
    Resultado = Soma % 11 < 2 ? 0 : 11 - (Soma % 11)
    if (Resultado !== parseInt(Digitos.charAt(1))) {
      return 'Digite um CPF ou CNPJ válido'
    }
    return true
  }
})

defineRule('nif', (value) => {
  if (!value || !value.length) {
    return true
  }

  if (value.length < 9) {
    return 'Caracteres insuficientes'
  }

  const resto =
    (value[7] * 2 + value[6] * 3 + value[5] * 4 + value[4] * 5 + value[3] * 6 + value[2] * 7 + value[1] * 8 + value[0] * 9) %
    11

  let control
  if (resto === 0 || resto === 1) {
    control = 0
  } else {
    control = 11 - resto
  }

  if (Number(value[8]) === control) {
    return true
  } else {
    return 'Digite um NIF válido'
  }
})

defineRule('onlyLetter', (value) => {
  if (!value || !value.length) {
    return true
  }
  const letter = value.replace(/\D/g, '')
  if (!/^[a-zA-Z]*$/g.test(letter)) {
    return 'Digite apenas letras'
  }
  return true
})

defineRule('creditCard', (value) => {
  if (!value || !value.length) {
    return true
  }
  const number = value.replace(/\D/g, '')
  let sum = 0
  let shouldDouble = false
  for (let i = number.length - 1; i >= 0; i--) {
    let digit = parseInt(number.charAt(i))
    if (shouldDouble) {
      if ((digit *= 2) > 9) digit -= 9
    }
    sum += digit
    shouldDouble = !shouldDouble
  }
  if (!(sum % 10 === 0)) {
    return 'Número inválido'
  }
  return true
})

defineRule('creditCardValidate', (value) => {
  if (!value || !value.length) {
    return true
  }

  const validate = value.replace(/\D/g, '')
  const __date = validate.replace(/(\d{2})\/(\d{2})\//, '$1/$2')
  const currentYear = new Date().getFullYear().toString().substr(-2)
  if (
    __date.slice(2, 4) < currentYear ||
    __date.slice(0, 2) > 12 ||
    __date.slice(0, 2) < 1 ||
    (__date.slice(2, 4) === currentYear && __date.slice(0, 2) < new Date().getMonth() + 1)
  ) {
    return 'Ano ou mês incorreto'
  }

  return true
})

defineRule('checkUserSocial', (value, [other]) => {
  if (!value || !value.length || !other) {
    return true
  }

  const ALLOWED_USER_SOCIAL = {
    facebook: {
      key: 'facebook',
      pattern: /^(https?:\/\/)?(www\.)?facebook\.com\/.*$/g
    },
    instagram: {
      key: 'instagram',
      pattern: /^(https?:\/\/)?(www\.)?instagram\.com\/.*$|(@[a-z]*)/g
    },
    linkedin: {
      key: 'linkedin',
      pattern: /^(https?:\/\/)?(www\.)?linkedin\.com\/.*$/g
    },
    youtube: {
      key: 'youtube',
      pattern: /^(https?:\/\/)?(www\.)?youtube\.com\/.*$/g
    },
    dribbble: {
      key: 'dribbble',
      pattern: /^(https?:\/\/)?(www\.)?dribbble\.com\/.*$/g
    },
    github: {
      key: 'github',
      pattern: /^(https?:\/\/)?(www\.)?github\.com\/.*$/g
    }
  }

  if (!ALLOWED_USER_SOCIAL[other.toLowerCase()].pattern.test(value)) {
    return 'Digite um link válido'
  }

  return true
})

defineRule('userSocial', (value) => {
  if (!value || !value.length) {
    return true
  }

  if (!/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/.test(value)) {
    return 'Digite um link válido'
  }

  return true
})

defineRule('removeAccentsAndSpecialCharacters', (value) => {
  if (!value || !value.length) {
    return true
  }

  const text = value.replace(/[^\w\s]/gi, '')
  if (value !== text) {
    return 'Digite o nome sem acentos e/ou caracteres especiais'
  }
  return true
})
